module.exports = __webpack_public_path__ + "static/media/icono_like.9f02e87c.svg";